
import { useState, useEffect } from 'react';
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { SwitchHorizontalIcon, ScaleIcon, DatabaseIcon, UserCircleIcon,
} from '@heroicons/react/outline'
import API from './api/api'
import Router from './api/router'
import { IconDashboard, IconChat  } from './Icons'
import { useNavigate, useLocation } from "react-router-dom"

import Body from './Components/Body'
import config from "./config"
import Logo from './media/images/logo.jpg'

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import blogs from './blogs.json';
import projects from './projects.json';

const Header = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const router   = new Router(navigate, location)
    const active   = router.is(config.route.base)
    console.log("Header - PATHS", location.pathname, config.route.base)

    const navClass = (route) => {
	console.log("PATHNAME", route, location.pathname)
        return ((route === location.pathname) ? "header-item-active" : "navigation-menu")
    }

    console.log("Header")

    useEffect(() => {
    }, {});


    const fromColor = () => {
	return "bg-red-200 text-red-600"
    }



    return (
    <>
    <Navbar collapseOnSelect expand="lg" className="header">
      <Container>
        <div className="mr-4">
            <NavLink to="/"><img src={Logo} alt={config.pageName} height={96} width={96} className="header-img brand-logo"/></NavLink>
        </div>
            <Navbar.Brand href={config.route.base} className={navClass(config.route.base)}>Sikkema Investments</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
              <Nav.Link href={config.route.overview} className={navClass(config.route.base)}>Overview</Nav.Link>
          </Nav>
          <Nav className="me-auto header">
            <NavDropdown href={config.route.portfolio} title="Portfolio" id="collapsible-nav-menu" className={navClass(config.route.portfolio)}>
              <NavDropdown.Item href={config.route.portfolio} className={navClass(config.route.portfolio)}>Overview</NavDropdown.Item>
            <NavDropdown.Divider/>
	    { Object.values(projects).map((project, index)=> (<NavDropdown.Item href={config.route.portfolio+"/"+index} className={navClass(config.route.portfolio+"/"+index)}>{project.title}</NavDropdown.Item>))}
            </NavDropdown>
          </Nav>
          <Nav className="me-auto header">
            <NavDropdown href={config.route.blog} title="Blog" id="collapsible-nav-menu" className={navClass(config.route.blog)}>
              <NavDropdown.Item href={config.route.blog} className={navClass(config.route.blog)}>Blog</NavDropdown.Item>
              <NavDropdown.Divider/>
	    { Object.values(blogs).map((blog, index)=> (<NavDropdown.Item href={config.route.blog+"/"+index} className={navClass(config.route.blog+"/"+index)}>{blog.title}</NavDropdown.Item>))}
	    </NavDropdown>
          </Nav>
          <Nav>
              <Nav.Link href={config.route.about} className={navClass(config.route.about)}>About</Nav.Link>
              <Nav.Link href={config.route.contact} className={navClass(config.route.contact)}>Contact</Nav.Link>
          </Nav>
         </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
}

export default Header
